const content = {
  getlist: 'content/getlist-by-admin',
  add: 'content/add',
  update: 'content/update',
  remove: 'content/remove',
  get: 'content/get-by-admin',
  getall: 'content/getall',
}
export default content
